/**
 * Generated runtime TestId mirror for frontend/src/components/identity/AccessTimeline.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const AccessTimelineTestIds = {
  accessTimeline: "access-timeline",
  timelineEmpty: "timeline-empty",
  timelineLoading: "timeline-loading",
  timelineComment: (event_id: string) => `timeline-comment-${event_id}`,
  timelineCommentPrefix: () => "timeline-comment-" as TestIdPrefix,
  timelineEvent: (event_id: string) => `timeline-event-${event_id}`,
  timelineEventPrefix: () => "timeline-event-" as TestIdPrefix,
  timelineEventType: (event_id: string) => `timeline-event-type-${event_id}`,
  timelineEventTypePrefix: () => "timeline-event-type-" as TestIdPrefix,
  timelineExpiry: (event_id: string) => `timeline-expiry-${event_id}`,
  timelineExpiryPrefix: () => "timeline-expiry-" as TestIdPrefix,
  timelinePerformer: (event_id: string) => `timeline-performer-${event_id}`,
  timelinePerformerPrefix: () => "timeline-performer-" as TestIdPrefix,
  timelineProfile: (event_id: string) => `timeline-profile-${event_id}`,
  timelineProfilePrefix: () => "timeline-profile-" as TestIdPrefix,
  timelineSource: (event_id: string) => `timeline-source-${event_id}`,
  timelineSourcePrefix: () => "timeline-source-" as TestIdPrefix
} as const;
